<template>
  <div v-loading.fullscreen="loading">
    <div v-if="!loading">
      <el-breadcrumb style="float: right" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }"> {{$t('route.home')}}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'categoryList' }"> {{$t('entities.category.plural')}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ model.name }}</el-breadcrumb-item>
      </el-breadcrumb>

      <h2 class="page-title">
         {{$t('entities.category.singular')}}
      </h2>

      <el-form
        :label-position="labelPosition"
        :label-width="labelWidth"
        :class="{ show: true, 'show-mobile': isMobile }"
        v-on:submit.native.prevent
      >
        <el-form-item label="Id">
          {{ model.id }}
        </el-form-item>

        <el-form-item label="Name">
          {{ model.name }}
        </el-form-item>

        <el-form-item label="Created at">
          {{ model.created | formatDatetime }}
        </el-form-item>

        <el-form-item label="Updated at">
          {{ model.modified | formatDatetime }}
        </el-form-item>

        <div class="button-group mt-3">
          <el-button
            v-if="hasRoleToUpdate"
            icon="el-icon-fa-pencil-square-o"
            @click="edit()"
            type="primary"
          >
            {{$t('table.edit')}}
          </el-button>
          <el-button
            v-if="hasRoleToReadLogs"
            icon="el-icon-fa-history"
            @click="history()"
            type="infor"
          >
            {{$t('table.history')}}
          </el-button>
          <el-button
            v-if="hasRoleToDelete"
            icon="el-icon-fa-trash"
            @click="destroy()"
            type="danger"
          >
            {{$t('table.delete')}}
          </el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'app-category-show',

  props: {
    id: String,
  },

  created() {
    this.$store
      .dispatch('entities/category/detail', this.id)
      .catch(() =>
        this.$router.push({ name: 'categoryList' }),
      );
  },

  beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/category/clear');
    next();
  },

  computed: {
    ...mapGetters({
      model: 'entities/category/model',
      loading: 'entities/category/loading',
      hasRoleToDelete: "entities/category/hasRoleToDelete",
      hasRoleToUpdate: "entities/category/hasRoleToUpdate",
      hasRoleToRead: "entities/category/hasRoleToRead",
      hasRoleToReadLogs: "entities/category/hasRoleToReadLogs",
      hasRoleToCreate: "entities/category/hasRoleToCreate",
      isMobile: "shared/isMobile",
      labelPosition: "shared/labelPosition",
      labelWidth: "shared/labelWidth"
    }),
  },

  methods: {
    edit() {
      this.$router.push({
        name: 'categoryEdit',
        params: { id: this.id, previous: 'show' },
      });
    },

    destroy() {
      this.$confirm('Are you sure?', 'Confirm', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
      })
        .then(() =>
          this.$store.dispatch(
            'entities/category/destroy',
            this.id,
          ),
        )
        .then(() =>
          this.$router.push({ name: 'categoryList' }),
        )
        .catch(() => {});
    },

    history() {
      this.$router.push({
        name: 'categoryHistorySingle',
        params: { id: this.id },
      });
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/entities/category/category-show.vue?4f9e002f